export default arr => arr.reduce((p, c) => ({ ...p, [c.type]: c }), {});
